<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-xsmall-size-100">
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-xsmall-size-50">
          <md-button
            style="z-index: 100"
            class="md-just-icon icon-add md-sm md-round"
            @click="referToInputPickFile"
          >
            <md-icon>photo_camera</md-icon>
          </md-button>
          <input
            id="iconImage"
            @change="addImg"
            type="file"
            accept="image/png, image/jpeg"
            ref="inputFile"
            style="display: none"
          />
          <img
            class="clickable"
            style="width: 100%"
            :src="form.pictureUrl ? form.pictureUrl : defaultAvatar"
            @dblclick="referToInputPickFile"
          />
          <div class="md-layout-item md-center" v-show="progress !== 100">
            <md-progress-bar
              class="md-info"
              :md-value="progress"
            ></md-progress-bar>
          </div>
        </div>
        <div
          class="md-layout-item md-size-90 md-xsmall-size-50 text-center info"
          v-bind:class="{ danger: parseInt(debtLimit) - debt < 0 }"
        >
          <p>{{ form.customerName }}</p>
          <p></p>
          <p>
            Công nợ:
            {{ debt >= 0 ? formatNumber(debt) : "-" + formatNumber(debt) }}
          </p>
          <p>Hạn mức công nợ: {{ formatMoney(debtLimit) }}</p>
          <p v-show="parseInt(debtLimit) - debt < 0" style="color: red">
            Công nợ vượt mức
          </p>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-75 md-xsmall-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <h4 class="title">
            <div class="md-layout">
              <div
                class="
                  md-layout-item md-size-5 md-xsmall-size-20
                  clickable
                  button-payment
                "
                @click="close"
              >
                <i class="fas fa-arrow-left"></i>
              </div>
              <div
                class="
                  md-layout-item md-size-20 md-xsmall-size-40
                  button-payment
                  clickable
                "
                v-bind:class="{ activeButton: isActive === 'paymentHistory' }"
                @click="isActive = 'paymentHistory'"
                v-show="!isAddCustomer"
              >
                LỊCH SỬ THANH TOÁN
              </div>
              <div
                class="
                  md-layout-item md-size-20 md-xsmall-size-40
                  button-payment
                  clickable
                "
                v-bind:class="{ activeButton: isActive === 'orderHistory' }"
                @click="isActive = 'orderHistory'"
                v-show="!isAddCustomer"
              >
                LỊCH SỬ ĐẶT HÀNG
              </div>
              <div
                class="
                  md-layout-item md-size-20 md-xsmall-size-50
                  button-payment
                  clickable
                "
                v-bind:class="{ activeButton: isActive === 'payment' }"
                @click="isActive = 'payment'"
                v-show="!isAddCustomer"
              >
                THANH TOÁN CÔNG NỢ
              </div>
              <div
                class="
                  md-layout-item md-size-20 md-xsmall-size-50
                  button-payment
                  clickable
                "
                v-bind:class="{ activeButton: isActive === 'info' }"
                @click="isActive = 'info'"
              >
                {{ isAddCustomer ? "THÊM ĐẠI LÝ" : "THÔNG TIN" }}
              </div>
            </div>
          </h4>
        </md-card-header>
        <md-card-content>
          <payment-history
            v-show="isActive === 'paymentHistory'"
            :db="db"
            :isReload="isReload"
            :customerSelected="customerSelected"
            :paymentHistory="dealHistory.payment"
          ></payment-history>
          <order-history
            v-show="isActive === 'orderHistory'"
            :orderHistory="dealHistory.order"
            :customerSelected="customerSelected"
          ></order-history>
          <payment
            v-if="isActive === 'payment'"
            :db="db"
            :listUser="listUser"
            :customerSelected="customerSelected"
            :listEmployee="listEmployee"
            @successPayment="successPayment"
          ></payment>
          <md-card class="customer-info" v-show="isActive === 'info'">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(submit)">
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Mã đại lý:</label>
                      <md-input
                        v-model="form.customerId"
                        required
                        type="text"
                        @change="isHaveAnyChange = true"
                        :disabled="!isAddCustomer"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Tên đại lý:</label>
                      <md-input
                        v-model="form.customerName"
                        required
                        type="text"
                        @change="isHaveAnyChange = true"
                        :disabled="!isAddCustomer"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Số điện thoại:</label>
                      <md-input
                        v-model="form.phone"
                        @change="isHaveAnyChange = true"
                        pattern="^\d.+$"
                        title="Số điện thoại không chứa ký tự đặc biệt"
                      >
                      </md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Thông tin kèm theo:</label>
                      <md-input
                        v-model="form.additionalInfo"
                        @change="isHaveAnyChange = true"
                      >
                      </md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-33 md-xsmall-size-100"
                    v-show="isAddCustomer"
                  >
                    <md-field>
                      <label>Công nợ ban đầu:</label>
                      <md-input
                        v-model="form.debt"
                        type="number"
                        required
                        min="0"
                      >
                      </md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-33 md-xsmall-size-100"
                    v-show="!isAddCustomer"
                  >
                    <md-field>
                      <label>Công nợ ban đầu:</label>
                      <md-input
                        readonly
                        v-model="form.debt"
                        @change="isHaveAnyChange = true"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Hạn mức công nợ:</label>
                      <md-input
                        required
                        v-model="form.debtLimit"
                        @change="isHaveAnyChange = true"
                        pattern="^[0-9.]+$"
                        :oninput="
                          (form.debtLimit = formatNumber(form.debtLimit))
                        "
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Chọn nhân viên:</label>
                      <md-select
                        v-model="employee"
                        @md-selected="selectEmployee"
                      >
                        <md-option
                          :key="index"
                          v-for="(item, index) in listEmployee"
                          :value="item.name + '$' + item.employeeCode"
                        >
                          {{ item.name + " - " + item.employeeCode }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-xsmall-size-100">
                    <p>Tên nhân viên: {{ form.employeeName }}</p>
                    <p>Mã nhân viên: {{ form.employeeCode }}</p>
                  </div>
                  <div class="md-layout md-size-33 md-xsmall-size-100">
                    <md-field>
                      <label>Địa chỉ:</label>
                      <md-textarea
                        v-model="form.address"
                        @change="isHaveAnyChange = true"
                        :md-autogrow="true"
                        type="text"
                        style="height: 50px"
                      ></md-textarea>
                    </md-field>

                    <md-field class="md-layout-item">
                      <label>Quận/Huyện</label>
                      <md-input
                        v-model="form.district"
                        @change="isHaveAnyChange = true"
                      >
                      </md-input>
                    </md-field>

                    <div class="md-layout-item">
                      <md-field>
                        <label>Tỉnh/Thành phố</label>
                        <md-input
                          v-model="form.province"
                          @change="isHaveAnyChange = true"
                          required
                        >
                        </md-input>
                      </md-field>
                    </div>
                  </div>
                </div>
                <md-button
                  type="submit"
                  class="md-success"
                  v-if="isAddCustomer"
                  :disabled="flagLoading"
                >
                  Hoàn tất
                </md-button>
                <md-button
                  type="submit"
                  class="md-success"
                  v-if="!isAddCustomer && isHaveAnyChange"
                  :disabled="flagLoading"
                >
                  Chỉnh sửa
                </md-button>
                <md-button class="md-danger" @click="close">Đóng</md-button>
              </form>
            </ValidationObserver>
          </md-card>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { ProductCard, NavTabsCard } from "@/components";
import firebase from "@/services/firebase-init.js";
import EventBus from "../../EventBus.js";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
export default {
  props: ["customerSelected", "isAddCustomer", "listUser"],
  components: {
    NavTabsCard,
    // MiniMap: () => import("./MiniMap"),
    Payment: () => import("./payment/Payment.vue"),
    PaymentHistory: () => import("./payment/PaymentHistory.vue"),
    OrderHistory: () => import("./payment/OrderHistory"),
  },
  created() {
    this.$store.dispatch("FLAG_LOADING", true);
    this.db = firebase.firestore();
    if (!this.isAddCustomer) {
      this.form = JSON.parse(JSON.stringify(this.customerSelected.data));
      // this.copyFrom = JSON.parse(JSON.stringify(this.form));
      this.employee = this.form.employeeName + "$" + this.form.employeeCode;
    }
    this.listUser.forEach((item) => {
      this.listEmployee.push(item.data);
    });
    this.debt = this.form.debt;
    let bits = localStorage.getItem("bits");
    this.storageRef = firebase
      .storage()
      .ref(process.env.VUE_APP_CUSTOMER + bits);
    this.db
      .collection(process.env.VUE_APP_ORDER + bits)
      .where("customerCode", "==", this.form.customerId)
      .orderBy("orderDate", "desc")
      .get()
      .then((doc) => {
        doc.forEach((item) => {
          if (
            item.data().status !== 4 &&
            item.data().paymentMethod !== "Thu tiền ngay"
          ) {
            this.debt += item.data().amount;
            console.log(this.debt);
            // console.log(item.data().amount);
          }
          if (item.data().isPayment) {
            this.dealHistory.payment.push(item.data());
          } else this.dealHistory.order.push(item.data());
        });
        this.$store.dispatch("FLAG_LOADING", false);
      })
      .catch((error) => {
        console.log(error);
        this.$store.dispatch("FLAG_LOADING", false);
      });
  },
  data() {
    return {
      isActive: this.isAddCustomer ? "info" : "paymentHistory",
      isHaveAnyChange: false,
      dealHistory: {
        order: [],
        payment: [],
      },
      debt: 0,
      isReload: false,
      isPayment: false,
      employee: "",
      db: {},
      storageRef: {},
      listEmployee: [],
      copyFrom: {},
      form: {
        province: "",
        district: "",
        debt: 0,
        debtLimit: "",
        phone: "",
        additionalInfo: "",
        address: "",
        customerId: "",
        customerName: "",
        employeeCode: "",
        employeeName: "",
        pictureUrl: "",
      },
      defaultAvatar: "./img/store.jpg",
      progress: 100,
    };
  },
  methods: {
    successPayment() {
      this.debt = 0;
      this.dealHistory.payment = [];
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_ORDER + bits)
        .where("customerCode", "==", this.form.customerId)
        .orderBy("orderDate", "desc")
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.debt += item.data().amount;
            if (item.data().isPayment) {
              this.dealHistory.payment.push(item.data());
            }
          });
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    closePayment() {
      this.isPayment = false;
    },
    openDialogPayment() {
      this.isPayment = true;
    },
    referToInputPickFile() {
      this.$refs.inputFile.click();
    },
    addImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.uploadImg(files[0]);
      }
    },
    uploadImg(file) {
      this.isHaveAnyChange = true;
      let fileReader = new FileReader();
      let _this = this;
      fileReader.onload = function (event) {
        var imagesRef = _this.storageRef
          .child(file.name)
          .putString(event.target.result, "data_url");
        imagesRef.on(
          "state_changed",
          (snapshot) => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            _this.progress = progress;
          },
          (error) => {
            this.$messageError(error.message);
          },
          () => {
            _this.$messageSuccess("Tải ảnh lên thành công");
            imagesRef.snapshot.ref.getDownloadURL().then((downloadURL) => {
              _this.form.pictureUrl = downloadURL;
              if (!_this.isAddCustomer) {
                _this.editCustomer();
              }
            });
          }
        );
      };
      fileReader.readAsDataURL(file);
    },
    selectLocation(item) {
      this.form.latitude = item.lat;
      this.form.longitude = item.lng;
    },
    selectEmployee(item) {
      this.isHaveAnyChange = true;
      let a = 0;
      a = item.indexOf("$");
      this.form.employeeName = item.slice(0, a);
      this.form.employeeCode = item.slice(a + 1);
    },
    submit() {
      this.isAddCustomer ? this.checkEmployeeCode() : this.editCustomer();
    },
    addNewCustomer() {
      while (
        isNaN(this.form.debtLimit) &&
        this.form.debtLimit.indexOf(".") !== -1
      ) {
        this.form.debtLimit = this.form.debtLimit.replace(/\./g, "");
      }
      this.form.debtLimit = parseInt(this.form.debtLimit);
      this.form.debt = parseInt(this.form.debt);
      this.isHaveAnyChange = false;
      this.form.debt *= -1;
      this.$store.dispatch("FLAG_LOADING", true);
      this.updateSuggesstionList();
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_CUSTOMER + bits)
        .add(this.form)
        .then((docRef) => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageSuccess("Thêm đại lý thành công!!!");
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageError("Không thành công, thử lại!!!");
        });
    },
    checkEmployeeName() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_CUSTOMER + bits)
        .where("customerName", "==", this.form.customerName)
        .get()
        .then((querySnapshot) => {
          var check = true;
          querySnapshot.forEach((item) => {
            if (item) {
              check = false;
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Tên đại lý đã tồn tại");
            }
          });
          if (check) this.addNewCustomer();
        });
    },
    checkEmployeeCode() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_CUSTOMER + bits)
        .where("customerId", "==", this.form.customerId)
        .get()
        .then((querySnapshot) => {
          var check = true;
          querySnapshot.forEach((item) => {
            if (item) {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Mã đại lý đã tồn tại");
              check = false;
            }
          });
          if (check) this.checkEmployeeName();
        });
    },
    editCustomer() {
      while (this.form.debtLimit.indexOf(".") !== -1) {
        this.form.debtLimit = this.form.debtLimit.replace(/\./, "");
      }
      this.form.debtLimit = parseInt(this.form.debtLimit);
      this.$store.dispatch("FLAG_LOADING", true);
      this.updateSuggesstionList();
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_CUSTOMER + bits)
        .doc(this.customerSelected.id)
        .update(this.form)
        .then(() => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageSuccess("Chỉnh sửa thông tin thành công");
          this.isHaveAnyChange = false;
          // this.copyFrom = JSON.parse(JSON.stringify(this.form));
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageError("Không thành công, thử lại");
        });
    },
    updateSuggesstionList() {
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_SUGGESTION_LIST)
        .doc("customer")
        .update({
          province: firebase.firestore.FieldValue.arrayUnion(
            this.form.province
          ),
        });
    },
    close() {
      this.isReload = false;
      if (this.isHaveAnyChange) {
        Swal.fire({
          title: "Thông báo",
          text: "Thông tin sẽ không được lưu",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: "Xác nhận",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            if (this.isAddCustomer) {
              this.$emit("close");
              EventBus.$emit("addNewCustomer");
            } else {
              this.$emit("close");
              EventBus.$emit("reloadCustomer", this.form.customerId);
            }
          }
        });
      } else {
        if (this.isAddCustomer) {
          this.$emit("close");
          EventBus.$emit("addNewCustomer");
        } else {
          this.$emit("close");
          EventBus.$emit("reloadCustomer", this.form.customerId);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["flagLoading"]),
    debtLimit() {
      let a = "";
      if (isNaN(this.form.debtLimit)) {
        a = this.form.debtLimit.replace(/\./g, "");
        return a;
      }
      return this.form.debtLimit;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-add {
  position: absolute;
  margin: -15px auto auto -15px;
}
.customer-info {
  margin-top: 0;
}
.button-back {
  position: absolute;
  z-index: 2;
  margin-top: 30px;
}
.info {
  padding: 5px;
  background-color: rgb(224, 224, 224);
  border-radius: 10px;
  box-shadow: 1px 1px 4px #88888817;
}
.danger {
  background: rgba(201, 0, 0, 0.144);
}
.info > p {
  color: black;
}
.button-payment {
  color: white;
  text-align: center;
  padding: 8px;
  background: #5f5f5f;
  font-size: 12px;
}
.activeButton {
  background: rgb(52, 146, 56);
  color: rgba(255, 255, 255, 0.897);
  font-weight: bold;
}
</style>
